var jquery = require('jquery');
window.$ = window.jQuery = jquery;

(function() {
  var $target;
  var $tabSection;

  if (window.location.hash !== '') {
    activateAccordion(getTargetFromHash(window.location.hash));
  }

  function activateAccordion($accordion) {
    if (!$accordion.length) { return; }

    $accordion.find('.accordion-body').slideToggle('fast', function() {
      $accordion.addClass('accordion-open');
      $accordion.find('.accordion-body').removeAttr('style');
    });

    scrollToTarget($accordion);
  }

  // Click Handlers
  $('.accordion').each(function() {
    var $accordion = $(this);

    $accordion.find('.accordion-header').on('click', function() {
      var target = $(this).data('target');

      // console.log(window.location.hash.substring(1), target)

      if (window.location.hash.substring(1) !== target) {
        updateHash(`#${target}`);
      }
      else {
        updateHash(window.location.pathname);
      }

      $accordion.find('.accordion-body').slideToggle('fast', function() {
        $accordion.toggleClass('accordion-open');
      });
    });
  });

  $(window).on('hashchange', function() {
    if (window.location.hash !== '') {
      activateAccordion(getTargetFromHash(window.location.hash));
    }
  })
})();

function getTargetFromHash(hash) {
  hash = hash[hash.length-1] === '/' ? hash.substring(1,hash.length-1) : hash.substring(1);
  return $('div[data-id="' + hash + '"]').first();
}

function scrollToTarget($target) {
  jQuery('html, body').animate({
    scrollTop: ($target.offset().top - 300)
  }, 500);
}

function updateHash(target) {
  if (window.history.pushState) {
    window.history.replaceState(null, null, target);
  }
  else {
    window.location.hash = target;
  }
}